import { z } from 'zod'

export const paramsSchema = z.object({
  cottageIds: z.array(z.string()),
  eventType: z.enum(['search_card_viz', 'search_free_cancellation']),
})

export type paramsType = z.infer<typeof paramsSchema>
